<template>
  <div class="no-results-wrapper">
      <div class="no-results">
          <div class="no-results__image">
            <img :src="image" alt="not found">
          </div>
          <div class="no-results__content">
            <h2 class="title">{{title || 'Engar niðurstöður fundust.'}}</h2>
            <p class="text">{{text || 'Prófaðu að breyta leitarskilyrðum eða vistaðu leit, við sendum tilkynningu um leið og það koma niðurstöður.'}}</p>
          </div>
          <div class="no-results__btn-wrapper">
            <router-link :to="getUrl" class="btn-primary">
                {{btnText || 'Hreinsa leitarskilyrði'}}
            </router-link>

            <save-search :filters="getFilter" style="margin-left: 12px;" />
          </div>
      </div>
  </div>
</template>
<script>

import SaveSearch from "@/components/SaveSearch";
import func from "@/helpers/func";
import {mapGetters} from "vuex";

export default {
  components: {
    SaveSearch
  },
  computed:{
    ...mapGetters({
      lib: "LIB"
    }),
    getUrl() {
      return {name:this.$route.name};
    },
    getFilter(){
      if(this.$route.name === 'DealersCars'){
        return  this.filter;
      }

      if(this.$route.name === 'OldCars' || this.$route.name === 'k7Cars') {
        let cleanFilter = func.cleanFilters(this.filter);
        return func.addFilersName(cleanFilter, this.lib);
      }
    }
  },
  props: ['image', 'title', 'text', 'btnText', 'allowSubscribe', 'subscribeText','filter']
}
</script>